export const isMobile = (ismobile) => {
  switch (ismobile) {
    case 'yes':
    case 'YES':
      return true;
    default:
      return false;
  }
};
